import lodash from 'lodash'
import Base from '../base.store'
import moment from "moment";
import { filter } from "../../../../utils/search";

const baseUrl = '/api/v1/master/lab-topic-methods'
const base = new Base(baseUrl)

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {}),
    getters: {
        ...base.getters
    },
    actions: {
        ...base.actions,
        cacheFindAll(context, { searchQuery, refLabTypeKey, where = [], options = {} }) {
            let force = false || options.force;
            const cacheDateResult = context.state.cacheDate.list;
            if (cacheDateResult && cacheDateResult.isBefore(moment())) {
                force = true
            }
            const wheres = [
                { name: 'refLabType.key', operator: '=', value: refLabTypeKey },
                { name: 'name', operator: 'like', value: searchQuery },
                ...where
            ]
            const sort = [{ name: 'name', type: 'ASC' }]
            const list = context.state.list || []
            if (list.length > 0 && !force) {
                return filter({ list, where: wheres, sort })
            }
            return context.dispatch('findAll', { criteria: { select: ['*', 'refLabType.*', 'refLabTopic.*'] } })
                .then(list => filter({ list, where: wheres, sort }))
        },
    },
    mutations: {
        ...base.mutations
    },
}
